<template>
  <div class="ownership-short">
    <user-short
      :id="`user-short-${uuid}`"
      :user-id="entity.ownerId"
      :length="length"
      :showUserName="showUserName"
      @mouseover.native="processMouseEvent('overUserShort', true, 200)"
      @mouseleave.native="processMouseEvent('overUserShort', false, 300)"
    ></user-short>
    <b-popover
      ref="popover"
      :show="showPopover"
      :target="`user-short-${uuid}`"
      placement="bottom"
      custom-class="ownership-viewer-popover"
      @hidden="overPopover = false"
    >
      <ownership-viewer
        ref="ownershipViewer"
        :entity="entity"
        :entity-type="entityType"
        :should-edit.sync="editing"
        @mouseover.native="processMouseEvent('overPopover', true, 0)"
        @mouseleave.native="processMouseEvent('overPopover', false)"
        @save="onOwnershipChange"
        @cancel="overPopover = false"
      ></ownership-viewer>
    </b-popover>
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
import OwnershipViewer from './OwnershipViewer'
import UserShort from './UserShort'
import EventBus from '@/EventBus'
import EventBusMixin from '@/mixins/EventBusMixin'

let uuid = 0

export default {
  name: 'OwnershipShort',
  components: {
    BPopover,
    UserShort,
    OwnershipViewer
  },
  props: ['entity', 'entityType', 'length', 'showUserName'],
  mixins: [EventBusMixin],
  beforeCreate() {
    this.uuid = 'ownership-short-' + uuid.toString()
    ++uuid
  },
  data() {
    return {
      overUserShort: false,
      overPopover: false,
      editing: false,
      timeouts: { overUserShort: null, overPopover: null }
    }
  },
  computed: {
    showPopover() {
      return this.overUserShort || this.overPopover || this.editing
    }
  },
  methods: {
    processMouseEvent(prop, value, timeout) {
      if (this.timeouts[prop]) {
        clearTimeout(this.timeouts[prop])
        this.timeouts[prop] = null
      }
      this.timeouts[prop] = setTimeout(() => {
        this[prop] = value
        this.timeouts[prop] = null
      }, timeout)
    },
    onOwnershipChange(updatedEntity) {
      this.overPopover = false
      if (updatedEntity.otype === 'goal') {
        EventBus.$emit('RELOAD_ACTIVITY_EVENTS', this.id)
      } else {
        EventBus.$emit('RELOAD_KR_EVENTS')
      }
      this.$emit('change', updatedEntity)
    }
  }
}
</script>

<style lang="scss" scoped>
.ownership-viewer-popover {
  border-radius: 16px;

  /deep/ .arrow {
    display: none;
  }
}

/deep/ .ownership-viewer-container {
  padding: 1.25rem;
}
</style>

<style lang="scss">
@import '~@/styles/styleConfigurations';

.ownership-viewer-popover .popover-body {
  padding: 0;
}

.popover-gap-filler {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 10px;
}

.ownership-viewer-popover.bs-popover-bottom .ownership-viewer-container:before {
  @extend .popover-gap-filler;
  top: -10px;
}

.ownership-viewer-popover.bs-popover-top .ownership-viewer-container:after {
  @extend .popover-gap-filler;
  bottom: -10px;
}

@include media-breakpoint-down(sm) {
  .ownership-viewer-popover {
    position: fixed !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate3d(-50%, -50%, 0) !important;
    min-width: 320px;
    box-shadow: 0px 10px 30px #9f9f9f !important;
  }
}
</style>
